import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import JWTService from "./../../services/JWTService"; // Giả sử bạn có service JWT
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../store/userSlice";
const AuthGuard = ({ children }) => {
    const dispatch = useDispatch();
    const state = useSelector((state) => state.user);
    const user = state.user;
    const navigate = useNavigate();
    useEffect(() => {
        if (!user || (user && JWTService.isTokenExpired(user.token))) {
            dispatch(logout(state));
            navigate("/login");
        }
    }, [user]);

    return <>{children}</>;
};

export default AuthGuard;
